/* eslint-disable react/display-name */
import { hiddenSelector } from '@smartsheet-dataflow/formjs';
import { connect, EntityId } from '@smartsheet-dataflow/formjs-react';
import React from 'react';
import { compose } from 'redux';
import { BridgeFormJSState } from '../../../services/forms/Types';

interface WithHiddenProps {
  hidden?: boolean;
}

const mapState = (state: BridgeFormJSState, { id }: EntityId) => ({
  id,
  hidden: hiddenSelector(id)(state),
});

const WithHiddenHOC =
  <P extends ReturnType<typeof mapState>>(Component: React.ComponentType<P>) =>
  (props: P & WithHiddenProps) =>
    props.hidden ? null : <Component {...props} />;

export const WithHidden = compose<React.FunctionComponent<EntityId>>(
  connect(mapState),
  WithHiddenHOC
);
